// extracted by mini-css-extract-plugin
module.exports = {"container":"NewPassword_container__patPR","paddingContainer":"NewPassword_paddingContainer__kvtoh","noPaddingContainer":"NewPassword_noPaddingContainer__jB7ZJ"};